<template>
    <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M-3.31596e-07 5.58603L0.701704 4.87509L3.62855 7.80194L3.62855 0.221679L4.64418 0.221679L4.64418 7.80194L7.56179 4.87509L8.27273 5.58603L4.13636 9.72239L-3.31596e-07 5.58603Z" fill="#00E1A5"/>
    </svg>
</template>